import { TextField } from '@mui/material';

export const DidFields = ({ selectedChannel, t }: any) => (
  <TextField
    label="DID Number"
    value={selectedChannel?.config?.credentials?.didNum ?? ''}
    disabled
    fullWidth
    margin="normal"
    sx={{ mt: 1, mb: 3 }}
    InputLabelProps={{ shrink: true }}
    placeholder={t?.('ENTER_DID_NUMBER') || 'Enter DID Number'}
  />
);
